// removed by extract-text-webpack-plugin
module.exports = {"menu":"_2QncI5Bf_8d25LTmYFtQqV","close":"_1mmt08_e3snTSfKfBC-F1s","item":"_2VJNWOFtBdcl2nIHuJyVg1","menuItems":"_4jHtta7VykFNBQ5CkU3cP","yadda":"_3PmVwGt-JebgfYMewmdoRo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileMenu/MobileMenu.module.scss
// module id = 790
// module chunks = 0